import { useEffect } from "react";
import CornerLadybug from "../images/corner/corner-ladybug-art.webp";
import Vineyard from "../images/vineyard.png";
import { renderStrapiContent } from "../utils/contentfulOptions";
import StrapiImage from "../components/StrapiImage";
import FullPageLoader from "../components/FullPageLoader";

const Winemakers = ({ info }) => {
  useEffect(() => {
    document.title = "Auburn Road - The Winemakers";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  if (!info) {
    return <FullPageLoader />;
  }

  const extractIframe = (htmlString) => {
    if (!htmlString) return null;
    const iframeMatch = htmlString.match(/<iframe[^>]*(?:\/>|><\/iframe>)/);
    if (iframeMatch) {
      let iframeHtml = iframeMatch[0];
      iframeHtml = iframeHtml.replace(/width="[^"]*"/, 'width="100%"');
      return { __html: iframeHtml };
    }
    return null;
  };

  const renderVideoBlock = (videoBlock, key) => {
    if (!videoBlock || !Array.isArray(videoBlock)) return null;

    const heading = videoBlock.find((block) => block.type === "heading");
    const paragraphs = videoBlock.filter((block) => block.type === "paragraph");
    const iframeParagraph = paragraphs.find(
      (p) =>
        p.children &&
        p.children[0] &&
        p.children[0].text &&
        p.children[0].text.includes("<iframe")
    );
    const textParagraphs = paragraphs.filter((p) => p !== iframeParagraph);

    return (
      <section className="content-section" key={key}>
        {heading && (
          <h2 className="content-section__heading">
            {heading.children.map((child, idx) => (
              <span key={idx}>{child.text}</span>
            ))}
          </h2>
        )}
        <div className="content-story__copy">
          {textParagraphs.map((para, idx) => (
            <p key={idx}>
              {para.children.map((child, childIdx) => (
                <span key={childIdx}>{child.text}</span>
              ))}
            </p>
          ))}
        </div>
        {iframeParagraph && iframeParagraph.children[0] && (
          <div
            className="content-media content-media--video"
            dangerouslySetInnerHTML={extractIframe(
              iframeParagraph.children[0].text
            )}
          />
        )}
      </section>
    );
  };

  return (
    <>
      <img
        className="corner-ladybug"
        src={CornerLadybug}
        alt="ladybug label - auburn road"
      />
      <div className="container content-page winemakers-page p-t-100">
        <section className="content-hero">
          <p className="content-hero__kicker">Meet the maker</p>
          <h1 className="huge-text-no-quote content-hero__title">
            Julianne Donnini
          </h1>
          {info.page_quote && (
            <p className="content-hero__intro">{info.page_quote}</p>
          )}
        </section>

        <section className="content-story">
          {info.winemaker_image && (
            <div className="content-story__media">
              <img
                className="content-story__photo"
                src={StrapiImage(info.winemaker_image, "medium")}
                alt={info.winemaker_image.alternativeText || "Julianne Donnini"}
              />
            </div>
          )}
          <div className="content-story__copy">
            {renderStrapiContent(info.meet_the_winemaker)}
          </div>
        </section>

        <section className="content-story">
          {info.jules_team && (
            <div className="content-story__media">
              <img
                className="content-story__photo"
                src={StrapiImage(info.jules_team, "small")}
                alt="winemakers at auburn road vineyard and winery"
              />
            </div>
          )}
          <div className="content-story__copy">
            {renderStrapiContent(info.meet_jules_team)}
          </div>
        </section>
      </div>

      <img src={Vineyard} className="corner-vineyard" alt="" />

      <div className="container content-page winemakers-page">
        <section className="content-story content-story--copy-only">
          <div className="content-story__copy">
            {renderStrapiContent(info.meet_the_vineyard)}
          </div>
        </section>
        {renderVideoBlock(info.video_block_one, "video-1")}
        {renderVideoBlock(info.video_block_two, "video-2")}
      </div>
    </>
  );
};

export default Winemakers;
